export interface SignOutOptions {
  plain: true
  microsoft: boolean
}

/** Which sign-out actions to offer. The Microsoft one needs a cached Microsoft account in a plain browser; Teams owns its own session and code-session users have no Microsoft account. */
export function signOutOptions(input: {
  host: 'teams' | 'browser' | null
  hasMicrosoftAccount: boolean
}): SignOutOptions {
  return { plain: true, microsoft: input.host === 'browser' && input.hasMicrosoftAccount }
}

/** Does Sign out ask first? Only when it could also end a Microsoft session; otherwise it signs out at once. */
export function signOutAsks(options: SignOutOptions): boolean {
  return options.microsoft
}
